import { ApexOptions } from 'apexcharts';
import { useIntl } from 'react-intl';

const chartOptions: ApexOptions = {
  chart: {
    id: 'revenue-column-card',
    fontFamily: 'Manrope, sans-serif',
    type: 'bar',

    toolbar: {
      show: false,
    },
    zoom: {
      enabled: false,
    },
  },
  labels: {
    style: {
      fontSize: '14px',
    },
  },

  dataLabels: {
    enabled: false,
  },

  grid: {
    borderColor: '#DFE6E9',
    row: {
      opacity: 0.5,
    },
  },
  plotOptions: {
    bar: {
      horizontal: false,
      borderRadius: 2,
      columnWidth: '45%',
      endingShape: 'rounded',
    },
    colors: {
      backgroundBarColors: ['#0063F7', '#00F7BF'],
    },
  },

  stroke: {
    width: 4,
    curve: 'smooth',
  },
  xaxis: {
    axisTicks: {
      show: false,
      borderType: 'solid',
      color: '#78909C',
      height: 6,
      offsetX: 0,
      offsetY: 0,
    },

    tickPlacement: 'between',
    labels: {
      style: {
        colors: ['636E72'],
        fontSize: '14px',
      },
    },
  },
  legend: {
    horizontalAlign: 'right',
    offsetX: 40,
    position: 'top',
    markers: {
      radius: 12,
    },
  },

  markers: {
    size: 6,
  },
};

export function useRentsPerMonthChartOptions(): {
  numberOfRents: ApexOptions;
  paymentValue: ApexOptions;
} {
  const intl = useIntl();
  const categories = [
    'Jan',
    'Fev',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ].map((month) => intl.formatMessage({ id: month }));

  return {
    numberOfRents: {
      ...chartOptions,
      labels: categories,
      ...{
        xaxis: {
          categories,
          labels: {
            show: true,
            style: {
              fontSize: '14px',
            },
          },
        },
        yaxis: [
          {
            labels: {
              style: {
                colors: '#636E72',
              },
            },
            title: {
              text: intl.formatMessage({ id: 'number-of-rents' }),
            },
          },
        ],
      },
    },
    paymentValue: {
      ...chartOptions,
      labels: categories,
      ...{
        xaxis: {
          categories,
          labels: {
            show: true,
            style: {
              fontSize: '14px',
            },
          },
        },
        yaxis: [
          {
            title: {
              text: ' Valores',
            },
          },
        ],

        colors: ['#00F7BF', '#1BE7FF'],
      },
    },
  };
}
